import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";
import { isMuted, setMuted, startAmbient, blip } from "@/lib/sound";

export default function SoundToggle() {
  const [muted, setMutedState] = useState(isMuted());

  useEffect(() => {
    const onFirstGesture = () => {
      startAmbient();
      window.removeEventListener("pointerdown", onFirstGesture);
    };
    window.addEventListener("pointerdown", onFirstGesture);

    let lastTick = 0;
    const onClick = (e) => {
      if (e.target.closest("a, button")) blip(520, 0.09, 0.09);
    };
    const onHover = (e) => {
      const now = performance.now();
      if (now - lastTick < 90) return;
      if (e.target.closest("a, button, [data-cursor]")) {
        lastTick = now;
        blip(880, 0.035, 0.03);
      }
    };
    document.addEventListener("click", onClick);
    document.addEventListener("mouseover", onHover);
    return () => {
      window.removeEventListener("pointerdown", onFirstGesture);
      document.removeEventListener("click", onClick);
      document.removeEventListener("mouseover", onHover);
    };
  }, []);

  const toggle = () => {
    const next = !muted;
    setMuted(next);
    setMutedState(next);
    if (!next) {
      startAmbient();
      blip(660, 0.12, 0.12);
    }
  };

  return (
    <motion.button
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2, type: "spring", stiffness: 260, damping: 20 }}
      onClick={toggle}
      className="fixed bottom-6 left-6 z-[110] w-12 h-12 rounded-full border border-white/15 bg-black/60 backdrop-blur-xl text-neutral-400 flex items-center justify-center hover:border-[#FF5A00] hover:text-[#FF5A00] transition-colors duration-300"
      aria-label={muted ? "Unmute sound" : "Mute sound"}
      data-testid="sound-toggle"
    >
      {muted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
    </motion.button>
  );
}
